<template lang="pug">
	.app-core--pager(v-if="pages && pages.length > 1")
		.page(v-for="page in pages", @click="v => changePageIndex(page)", :class="{ active: page === pageIndex }") {{page + 1}}
</template>

<script>

export default {
	model: {
		prop: 'pageIndex',
		event: 'change'
	},
	props: ['count', 'pageIndex'],
	computed: {
		pages() {
			var pages = [];

			var addPage = (idx) => {
				if (idx >= 0 && idx <= this.count - 1 && pages.indexOf(idx) === -1) {
					pages.push(idx);
				}
			};

			if (this.count > 1) {
				addPage(0);

				addPage(this.pageIndex-2);
				addPage(this.pageIndex-1);
				addPage(this.pageIndex);
				addPage(this.pageIndex+1);
				addPage(this.pageIndex+2);

				addPage(this.count-1);
			}

			return pages;
		}
	},
	methods: {
		changePageIndex(idx) {
			this.$emit('change', idx);
		}
	}
};
</script>
<style lang="scss">
	.app-core--pager {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		user-select: none;

		> .page {
			padding: 8px;
			min-width: 30px;
			text-align: center;
			border-radius: 4px;
			cursor: pointer;

			&.active {
				background: rgba(0,0,0,0.1);
			}
		}
	}
</style>
